<template>
  <div id="findPass">
      <h1>找回密码</h1>
      <el-button @click="goLogin">返回登录页面</el-button>
  </div>
</template>

<script>
export default {
    data(){
        return{
           
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        goLogin(){
            this.$emit('toogle','login')
        }
    }
}
</script>

<style lang="less" scoped>

</style>